module.exports = __webpack_public_path__ + "img/ws_1.9cd1282f.png";